<script setup lang="ts">
useDefaultMeta({
  title: 'Klaim Asuransi Pengiriman & Return Cepat, Mudah, & Aman',
  description:
    'Ajukan klaim asuransi paket rusak atau hilang dengan cepat dan mudah lewat KiriminAja. Proses transparan, pencairan langsung ke akun member.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Bagaimana cara mengajukan klaim asuransi di KiriminAja?',
    answer:
      'Masuk ke dashboard, pilih paket bermasalah, isi laporan klaim, unggah bukti, dan pantau prosesnya secara real-time.'
  },
  {
    question: 'Berapa lama waktu penyelesaian klaim?',
    answer:
      'Estimasi penyelesaian mengikuti SLA yang sudah ditentukan dan transparan di dashboard sejak awal proses.'
  },
  {
    question: 'Apakah semua paket otomatis diasuransikan?',
    answer:
      'Paket dengan nilai di atas Rp500.000 wajib diasuransikan. Namun kamu bisa memilih asuransi tambahan untuk nilai barang di bawahnya.'
  },
  {
    question: 'Bagaimana jika paket retur mengalami kerusakan?',
    answer:
      'Kamu bisa mengajukan klaim retur langsung melalui dashboard KiriminAja tanpa proses manual tambahan.'
  },
  {
    question: 'Apakah pencairan dana klaim dilakukan otomatis?',
    answer:
      'Ya, setelah klaim disetujui, dana otomatis masuk ke saldo member KiriminAja tanpa perlu proses administrasi manual.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Paket Hilang atau Rusak? Tenang, KiriminAja Siaga Sampai Tuntas"
      sub-title="Klaim Asuransi & Return"
      description="Fitur Klaim Asuransi & Retur KiriminAja memastikan proses penggantian berjalan cepat, transparan, dan tanpa ribet — karena keamanan kirimanmu adalah prioritas kami."
      hero-image="/images/klaim-asuransi-dan-retur-banner-1.webp"
      button-label="Ajukan Klaim"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/package-claim'
        })
      "
    />

    <KeunggulanKlaimAsuransiDanReturSection1 />
    <KeunggulanKlaimAsuransiDanReturSection2 />
    <KeunggulanKlaimAsuransiDanReturSection3 />
    <KeunggulanKlaimAsuransiDanReturSection4 />
    <FaqBase :faqs="faqs" />
    <KeunggulanKlaimAsuransiDanReturCta />
  </div>
</template>
